import { type ReactNode } from 'react';

const badgeColors = {
  gray: 'bg-gray-100 text-gray-700',
  blue: 'bg-blue-100 text-blue-700',
  green: 'bg-green-100 text-green-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  red: 'bg-red-100 text-red-700',
  purple: 'bg-purple-100 text-purple-700',
  orange: 'bg-orange-100 text-orange-700',
  primary: 'bg-primary-100 text-primary-700',
} as const;

interface BadgeProps {
  color?: keyof typeof badgeColors;
  children: ReactNode;
  className?: string;
}

export function Badge({ color = 'gray', className = '', children }: BadgeProps) {
  return (
    <span className={`inline-flex items-center text-xs font-medium px-2 py-0.5 rounded-full ${badgeColors[color]} ${className}`}>
      {children}
    </span>
  );
}
